"use client";

import NewRelicScript from "@/components/integrations/NewRelicScript";
import { useAuth } from "@/hooks/useAuth";
import { useMonitoringPreference } from "@/context/MonitoringPreferenceContext";

/**
 * Mounts the New Relic browser agent for a signed-in user who has not objected.
 *
 * The agent stores nothing on the device, so what it reports is attributed by handing it
 * the Cognito subject rather than by a stored session identifier — better attribution
 * than the identifier gave us, since it follows the person across browsers.
 *
 * It stays out of the public pages deliberately: before sign-in there is no user, so
 * there is no way to know whether that person has objected, and monitoring somebody who
 * opted out is worse than missing a login-page error.
 */
export default function PerformanceMonitoring() {
  const { user } = useAuth();
  const { monitoringAllowed } = useMonitoringPreference();

  if (!user || !monitoringAllowed) return null;
  return <NewRelicScript userId={user.userId} />;
}
